import { render, staticRenderFns } from "./wheelCenterImagePicker.vue?vue&type=template&id=36a4b7be&scoped=true"
import script from "./wheelCenterImagePicker.vue?vue&type=script&lang=js"
export * from "./wheelCenterImagePicker.vue?vue&type=script&lang=js"
import style0 from "./wheelCenterImagePicker.vue?vue&type=style&index=0&id=36a4b7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a4b7be",
  null
  
)

export default component.exports